module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEUAAACnej3aAAAAAXRSTlMz/za5cAAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/template/ie8_opacity_dark_20.png
// module id = ../../../../../src/assets/img/template/ie8_opacity_dark_20.png
// module chunks = 2